import axiosInstance from "../../../utils/axios";

const path = "admin/auth"
const path2 = "common/auth"

export const login = async (values) => {
    return await axiosInstance().post(`${path}/login`, values);
}
export const portalLogin = async (values) => {
    return await axiosInstance().post(`${path2}/login`, values);
}


export const forgetPassword = async (values) => {
    return await axiosInstance().post(`${path}/forgot-password`, values);
}

export const otpVerification = async (values) => {
    return await axiosInstance().post(`${path}/verify-otp`, values);
}

export const resetPassword = async (values) => {
    return await axiosInstance().patch(`${path}/reset-password`, values);
}

export const resendOtp = async (values) => {
    return await axiosInstance().post(`${path}/resend-otp`, values);
}

export const InvitationInfo = async (values) => {
    return await axiosInstance().post(`${path}/invitation-info`, values);
}

export const CompleteInvitation = async (values) => {
    return await axiosInstance().post(`${path}/complete-invitation`, values);
}
